import { apiClient } from "@/api/api-client";
import createBaseService, { type Pagination } from "@/api/base-service.ts";
import type {
	FormTemplate,
	// FormTemplateCreateFormSchema,
	FormTemplateFormSchema,
	// UserAssignFormSchema,
	// UserCreateFormSchema,
	// UserFormSchema,
} from "@/features/dashboard/types/form-template.ts";

const formTemplateService = {
	...createBaseService<FormTemplate>("/form-templates"),

	listById: async (params = {}) => {
		const response = await apiClient.get<{ data: T[]; meta: Pagination }>(
			// `/form-templates/${id}/activities`,
			"/form-templates/",
			{ params },
		);

		return response.data;
	},

	create: async (data: FormTemplateFormSchema) => {
		const response = await apiClient.post<{ data: FormTemplate }>(
			"/form-templates",
			data,
		);

		return response.data.data;
	},
	updateById: async (data: FormTemplateFormSchema) => {
		const response = await apiClient.put<{ data: FormTemplate }>(
			`/form-templates/${data.id}`,
			data,
		);

		return response.data.data;
	},
	// removeRole: async (data: UserAssignFormSchema) => {
	// 	return await apiClient.put(`/users/${data.user_id}/roles`, data);
	// },
	// disable: async (id: string): Promise<void> => {
	// 	return await apiClient.post(`/users/${id}/disable`);
	// },
	// enable: async (id: string): Promise<void> => {
	// 	return await apiClient.post(`/users/${id}/enable`);
	// },
};

export default formTemplateService;
